import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
	Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { delay, map, switchMap, take } from 'rxjs/operators';

import { AuthService } from '@core/services/auth.service';
import { UserState } from '@shared/interfaces';
import { CartService } from '@core/services';
import { isPlatformServer } from '@angular/common';

@Injectable({
	providedIn: 'root',
})
export class UserStateResolver implements Resolve<UserState> {
	constructor(
		private authService: AuthService,
		private cartService: CartService,
		@Inject(PLATFORM_ID) private platformId: any
	) {}
	resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<UserState> {
		return this.authService.getUserState$().pipe(
			take(1),
			delay(500),
			switchMap((userState: UserState) => {
				if (isPlatformServer(this.platformId)) {
					return of({});
				}
				// if (userState?.guid) {
				// 	return of({});
				// }
				return this.cartService.initializeCart$(userState).pipe(
					take(1),
					map(() => userState)
				);
			})
		);
	}
}
